import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const PATHOLOGY_PATH = "/pathology/v1";

// Pathology

export const getPathologyApi = async (params) =>
  await getRequest(`${PATHOLOGY_PATH}/list`, params);

export const getPathologyByIdApi = async (params) =>
  await getRequest(`${PATHOLOGY_PATH}/request/${params?.id}`);

export const updatePathologyApi = async (id, body) =>
  await putRequest(`${PATHOLOGY_PATH}/request/${id}`, body);

export const printPathologyApi = async (id) =>
  await getRequest(`${PATHOLOGY_PATH}/report/${id}/pdf`, {}, true);

export const deletePathologyByIdApi = async (id) =>
  await deleteRequest(`${PATHOLOGY_PATH}/request/${id}`);
